var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogotypeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 30C40 35.525 35.525 40 30 40C30 34.475 34.475 30 40 30Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26V30C34.475 30 30 34.475 30 40H26C26 32.275 32.275 26 40 26Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22V26C36.85 26 33.8 25.425 31 24.4C33.65 22.875 36.725 22 40 22Z",
    fill: "#001A21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0012 18V22C36.7262 22 33.6262 21.275 30.8262 20C33.6262 18.725 36.7262 18 40.0012 18Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14V18C36.725 18 33.65 17.125 31 15.6C33.8 14.575 36.85 14 40 14Z",
    fill: "#001A21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10V14C32.275 14 26 7.725 26 0H30C30 5.525 34.475 10 40 10Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C35.525 0 40 4.475 40 10C34.475 10 30 5.525 30 0Z",
    fill: "#00F2F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 14C36.8504 14 33.8004 14.575 31.0004 15.6C28.2504 14.025 25.9754 11.725 24.4004 9C25.4254 6.2 26.0004 3.175 26.0004 0C26.0004 7.725 32.2754 14 40.0004 14Z",
    fill: "#00F2F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0004 24.3998C33.8004 25.4248 36.8254 25.9998 40.0004 25.9998C32.2754 25.9998 26.0004 32.2748 26.0004 39.9998C26.0004 36.8498 25.4254 33.7998 24.4004 30.9998C26.0004 28.2748 28.2754 25.9748 31.0004 24.3998Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9988 18.0002C36.7238 18.0002 33.6238 18.7252 30.8238 20.0002C29.3988 19.3502 28.0488 18.5252 26.7988 17.6002C28.1238 16.8002 29.5488 16.1502 30.9988 15.6002C33.6488 17.1252 36.7238 18.0002 39.9988 18.0002Z",
    fill: "#FFCB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8238 20C33.6238 21.275 36.7238 22 39.9988 22C36.7238 22 33.6488 22.875 30.9988 24.4C29.5238 23.85 28.1238 23.2 26.7988 22.4C28.0488 21.45 29.3988 20.65 30.8238 20Z",
    fill: "#00F2F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4004 9C25.9754 11.75 28.2754 14.025 31.0004 15.6C29.5254 16.15 28.1254 16.825 26.8004 17.6C25.1254 16.35 23.6504 14.875 22.4004 13.2C23.2004 11.875 23.8504 10.45 24.4004 9Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0004 24.3998C28.2504 25.9748 25.9754 28.2748 24.4004 30.9998C23.8504 29.5248 23.1754 28.1248 22.4004 26.7998C23.6504 25.1248 25.1254 23.6498 26.8004 22.3998C28.1254 23.1998 29.5504 23.8498 31.0004 24.3998Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 17.6002C28.05 18.5502 29.4 19.3502 30.825 20.0002C29.4 20.6502 28.05 21.4502 26.8 22.4002C25.6 21.7002 24.45 20.8752 23.375 20.0002C24.45 19.1002 25.6 18.3002 26.8 17.6002Z",
    fill: "#001A21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H22C22 36.725 22.875 33.65 24.4 31C25.425 33.8 26 36.825 26 40Z",
    fill: "#001A21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0C26 3.15 25.425 6.2 24.4 9C22.875 6.35 22 3.275 22 0H26Z",
    fill: "#001A21"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 13.1998C23.65 14.8748 25.125 16.3498 26.8 17.5998C25.6 18.2998 24.45 19.1248 23.375 19.9998C22.15 18.9748 21 17.8498 20 16.5998C20.9 15.5498 21.7 14.3998 22.4 13.1998Z",
    fill: "#00F2F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 22.3998C25.125 23.6498 23.65 25.1248 22.4 26.7998C21.7 25.5998 20.875 24.4498 20 23.3998C21.025 22.1748 22.15 21.0248 23.375 20.0248C24.45 20.8748 25.6 21.6998 26.8 22.3998Z",
    fill: "#FFCB00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C22 3.275 22.875 6.35 24.4 9C23.85 10.475 23.175 11.875 22.4 13.2C21.45 11.95 20.65 10.6 20 9.175C21.275 6.375 22 3.275 22 0Z",
    fill: "#FFCB00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 31.0002C22.875 33.6502 22 36.7252 22 40.0002C22 36.7252 21.275 33.6252 20 30.8252C20.65 29.4002 21.475 28.0502 22.4 26.8002C23.2 28.1252 23.85 29.5252 24.4 31.0002Z",
    fill: "#00F2F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H22C22 3.275 21.275 6.375 20 9.175C18.725 6.375 18 3.275 18 0Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39.9998H18C18 36.7248 18.725 33.6248 20 30.8248C21.275 33.6248 22 36.7248 22 39.9998Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.4002C21.864 23.4002 23.375 21.878 23.375 20.0002C23.375 18.1225 21.864 16.6002 20 16.6002C18.136 16.6002 16.625 18.1225 16.625 20.0002C16.625 21.878 18.136 23.4002 20 23.4002Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3996 13.2002C21.6996 14.4002 20.8746 15.5502 19.9996 16.6002C19.0996 15.5252 18.2996 14.4002 17.5996 13.2002C18.5496 11.9502 19.3496 10.6002 19.9996 9.17517C20.6496 10.6002 21.4746 11.9502 22.3996 13.2002Z",
    fill: "#001A21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 23.375C20.8996 24.45 21.6996 25.575 22.3996 26.775C21.4496 28.025 20.6496 29.375 19.9996 30.8C19.3496 29.375 18.5246 28.025 17.5996 26.775C18.2996 25.6 19.0996 24.45 19.9996 23.375Z",
    fill: "#001A21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 0C17.9996 3.275 18.7246 6.375 19.9996 9.175C19.3496 10.6 18.5246 11.95 17.5996 13.2C16.8246 11.875 16.1496 10.45 15.5996 9C17.1246 6.35 17.9996 3.275 17.9996 0Z",
    fill: "#00F2F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 30.8252C18.7246 33.6252 17.9996 36.7252 17.9996 40.0002C17.9996 36.7252 17.1246 33.6502 15.5996 31.0002C16.1496 29.5252 16.8246 28.1252 17.5996 26.8002C18.5246 28.0502 19.3496 29.4002 19.9996 30.8252Z",
    fill: "#FFCB00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40H14C14 36.85 14.575 33.8 15.6 31C17.125 33.65 18 36.725 18 40Z",
    fill: "#001A21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C18 3.275 17.125 6.35 15.6 9C14.575 6.2 14 3.15 14 0H18Z",
    fill: "#001A21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 13.1998C18.2996 14.3998 19.1246 15.5498 19.9996 16.5998C18.9746 17.8248 17.8496 18.9748 16.6246 19.9998C15.5496 19.0998 14.4246 18.2998 13.2246 17.5998C14.8746 16.3498 16.3496 14.8748 17.5996 13.1998Z",
    fill: "#FFCB00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0012 23.3752C19.1012 24.4502 18.3012 25.5752 17.6012 26.7752C16.3512 25.1002 14.8762 23.6252 13.2012 22.3752C14.4012 21.6752 15.5512 20.8502 16.6012 19.9752C17.8512 21.0252 18.9762 22.1502 20.0012 23.3752Z",
    fill: "#00F2F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 13.2C16.3496 14.875 14.8746 16.35 13.1996 17.6C11.8746 16.8 10.4496 16.15 8.97461 15.6C11.7246 14.025 13.9996 11.725 15.5746 9C16.1496 10.45 16.8246 11.875 17.5996 13.2Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 22.3998C14.875 23.6498 16.35 25.1248 17.6 26.7998C16.825 28.1248 16.15 29.5498 15.6 30.9998C14.025 28.2498 11.725 25.9748 9 24.3998C10.475 23.8498 11.875 23.1998 13.2 22.3998Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C14 3.15 14.575 6.2 15.6 9C14.025 11.75 11.725 14.025 9 15.6C6.2 14.575 3.15 14 0 14C7.725 14 14 7.725 14 0Z",
    fill: "#FFCB00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 30.9998C14.575 33.7998 14 36.8248 14 39.9998C14 32.2748 7.725 25.9998 0 25.9998C3.15 25.9998 6.2 25.4248 9 24.3998C11.725 25.9748 14.025 28.2748 15.6 30.9998Z",
    fill: "#00F2F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H14C14 7.725 7.725 14 0 14V10C5.525 10 10 5.525 10 0Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14 40H10C10 34.475 5.525 30 0 30V26C7.725 26 14 32.275 14 40Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1988 17.6002C14.3988 18.3002 15.5488 19.1252 16.5988 20.0002C15.5238 20.8752 14.3988 21.7002 13.1988 22.4002C11.9488 21.4502 10.5988 20.6502 9.17383 20.0002C10.5988 19.3502 11.9488 18.5252 13.1988 17.6002Z",
    fill: "#001A21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 17.6002C11.95 18.5252 10.6 19.3502 9.175 20.0002C6.375 18.7252 3.275 18.0002 0 18.0002C3.275 18.0002 6.35 17.1252 9 15.6002C10.475 16.1252 11.875 16.8002 13.2 17.6002Z",
    fill: "#00F2F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.175 20C10.6 20.65 11.95 21.45 13.2 22.4C11.875 23.2 10.45 23.85 8.975 24.4C6.35 22.875 3.275 22 0 22C3.275 22 6.375 21.275 9.175 20Z",
    fill: "#FFCB00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C10 5.525 5.525 10 0 10C0 4.475 4.475 0 10 0Z",
    fill: "#FFCB00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C5.525 30 10 34.475 10 40C4.475 40 0 35.525 0 30Z",
    fill: "#00F2F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C3.275 18 6.375 18.725 9.175 20C6.375 21.275 3.275 22 0 22V18Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.6C6.35 17.125 3.275 18 0 18V14C3.15 14 6.2 14.575 9 15.6Z",
    fill: "#001A21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C3.275 22 6.35 22.875 9 24.4C6.2 25.425 3.175 26 0 26V22Z",
    fill: "#001A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeSmall);
export default __webpack_public_path__ + "static/media/logotype_small.1e147a0c592d3a824338db414b426851.svg";
export { ForwardRef as ReactComponent };